<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top:20px;">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="stuName" placeholder="请输入学生名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="schoolName" placeholder="请输入学校名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="examName" placeholder="请输入考核名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="idCard" placeholder="请输入身份证号"  clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="certificateNum" placeholder="请输入证书编号" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="examinationTypeId" clearable filterable  placeholder="请选择考核类型" @change="typeChnage">
                        <el-option v-for="item in searchCertTypeList" :key="item.value" :label="item.label" 
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="examinationGradeId" clearable placeholder="请选择考核等级">
                        <el-option v-for="item in searCertGradeList" :key="item.value" :label="item.lable"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getStudentResultInfo()">搜索</el-button>
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addInfo">新增</el-button>
                    <el-button type="primary" @click="ImportDialogVisible = true">导入</el-button>
                    <el-button type="primary" icon="el-icon-delete" @click="multiDeleteCertificate">删除</el-button>
                    <el-button type="primary" @click="openTXtDialog()">上传头像</el-button>
                    <el-button type="primary" @click="multiCreateCertificate()">生成证书</el-button>
                    <el-button type="primary" @click="exportCertificateZip">批量导出证书</el-button>
                    <a class="export-button-a" style="color: #fff; margin-left: 10px" :href="exportExam">导出</a>

                    <importPhoto btnName="批量导入国际证书" @refresh="getStudentResultInfo"></importPhoto>
                </el-form-item>
            </el-form>
        </header>
        <div style="padding-left:30px;">
            <el-table
                class="certificate-manager-table"
                :data="list"
                height="calc(100vh - 300px)"
                border
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column prop="id" type="selection" width="50" fixed="left"></el-table-column>
                <el-table-column label="序号" type="index" width="60" fixed="left"></el-table-column>
                <el-table-column
                    prop="studentName"
                    label="学生姓名"
                    width="110"
                    fixed="left"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="idCard" label="身份证号" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examName" label="考核名称" min-width="220" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examTime" label="考核时间" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="examinationGrade" label="证书等级" width="110" show-overflow-tooltip></el-table-column>
                <el-table-column prop="siteName" label="考核站点" min-width="170" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dateofIssue" label="发证时间" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="certificateNum" label="证书编号" width="170" show-overflow-tooltip></el-table-column>
                <el-table-column prop="certificateType" label="证书类型" min-width="220" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dateCreated" label="创建日期" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="certificateUrl" label="电子证书" width="100">
                    <template slot-scope="scope">
                        <img v-if="scope.row.certificateUrl" style="height: 60px" :src="scope.row.certificateUrl"
                            @click="clickImg(scope.row.certificateUrl)" />
                        <span v-else>未生成</span>
                    </template>
                </el-table-column>
                <el-table-column prop="effectiveTime" label="照片" width="80">
                    <template slot-scope="scope">
                        <img :src="scope.row.studentUrl" height="50" width="50" v-if="scope.row.studentUrl" />
                        <img src="/static/img/default_avatar3.24690a70.png" height="50" width="50" v-else />
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="340" fixed="right" class-name="certificate-operation-column">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button size="mini" type="primary"
                            @click="handleCreatedCertificate(scope.row.id)">生成证书</el-button>
                        <el-button v-if="scope.row.certificateUrl" size="mini" type="success"
                            @click="exportCertificate(scope.row)">导出证书</el-button>
                        <el-button size="mini" type="danger" @click="deleteInfo(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-page-con">
                <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler"
                    :current-page="page" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCount" v-show="totalCount > 0"
                    style="text-align: center;"></el-pagination>
            </div>
        </div>

        <el-dialog :title="titleFormVisible" :visible.sync="dialogFormVisible" :append-to-body="true" width="800px">
            <el-form :inline="true" :model="from" class="demo-form-inline" label-width="120px" size="small">
                <el-form-item label="学生姓名">
                    <el-input v-model="from.studentName"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="from.idCard" @change="handleIdCardChange"></el-input>
                </el-form-item>
                <el-form-item label="考核名称">
                    <el-input v-model="from.examName"></el-input>
                </el-form-item>
                <el-form-item label="考核时间">
                    <el-date-picker type="date" placeholder="选择日期" v-model="from.examTime"
                        style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="证书编号">
                    <el-input v-model="from.certificateNum"></el-input>
                </el-form-item>
                <el-form-item label="发证时间">
                    <el-date-picker type="date" placeholder="选择日期" v-model="from.dateofIssue"
                        style="width: 100%;"></el-date-picker>
                </el-form-item>
                <el-form-item label="证书类型">
                    <el-select v-model="from.examinationTypeId" placeholder="请选择" @change="typeChnage">
                        <el-option v-for="item in certTypeList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证书等级">
                    <el-select v-model="from.examinationGradeId" placeholder="请选择">
                        <el-option v-for="item in certGradeList" :key="item.value" :label="item.lable"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考核站点">
                    <el-input v-model="from.siteName"></el-input>
                </el-form-item>
                <el-form-item v-show="from.examYMEnglish != ''" label="考核年月英文">
                    <el-input disabled v-model="from.examYMEnglish"></el-input>
                </el-form-item>
                <el-form-item v-show="from.examinationGradeEnglish != ''" label="考核等级英文">
                    <el-input disabled v-model="from.examinationGradeEnglish"></el-input>
                </el-form-item>
                <el-form-item label="考生姓名拼音">
                    <el-input v-model="from.studentNamePinyin"></el-input>
                </el-form-item>
                <el-form-item label="证书方向">
                    <el-input v-model="from.zsfx"></el-input>
                </el-form-item>
                <el-form-item label="考生性别">
                    <el-select v-model="from.sex" placeholder="请选择" :disabled="isSexDisabled">
                        <el-option label="男" :value="0"></el-option>
                        <el-option label="女" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="考生头像">
                    <imageUpload class="img_upload" :url="urlAliyunOSS" :files.sync="from.studentUrl"
                        v-if="dialogFormVisible" format="image"></imageUpload>
                </el-form-item>
                <el-form-item label="证书">
                    <imageUpload class="img_upload" :url="urlAliyunOSS" :files.sync="from.certificateUrl"
                        v-if="dialogFormVisible" format="image"></imageUpload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelInfo">取 消</el-button>
                <el-button type="primary" @click="editInfo()">确 定</el-button>
            </div>
        </el-dialog>

        <!-- 导入考生成绩 -->
        <el-dialog title="Excel批量导入证书信息" :close-on-click-modal="false" :visible.sync="ImportDialogVisible" width="740px"
            class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="top-tip-con">
                    <div class="clearfix">
                        <span class="fl">操作提示：</span>
                        <div class="fl tip-article-con">
                            为了方便您的工作，我们已经准备好了《考生证书信息导入》的标准模版，请您先下载考生证书导入标准模版，填写后选择填写好的模版导入数据即可，
                            <span class="mark-tip">
                                为了能够准确的导入数据，请务必按照标准模版的要求进行填写。
                            </span>
                        </div>
                    </div>
                    <div class="download-model-con">
                        <a :href="wordUrl" class="el-link">
                            <el-button type="primary" class="download-model-btn">下载考生证书信息导入模版</el-button>
                        </a>
                    </div>
                </div>
                <div class="import-table-con">
                    <p>
                        <i class="kz-icon-tishi"></i> 请选择要导入的考生证书信息表格
                    </p>
                    <el-upload class="upload-demo" ref="upload" :action="uploadUrl" :file-list="fileList"
                        :auto-upload="false" :on-success="onSuccess" accept="xls" :limit="1"
                        style="display: inline-block; text-align: center;margin-top:15px;">
                        <el-button slot="trigger" type="primary">选择导入文件</el-button>
                        <div slot="tip" class="el-upload__tip"></div>
                    </el-upload>
                    <!-- <el-button type="primary" class="select-impoort-file">选择导入文件</el-button> -->
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="ImportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="importFile">确定导入</el-button>
            </span>
        </el-dialog>
        <!-- 进度条 -->
        <el-dialog title="数据导入中。。。" :close-on-click-modal="true" :visible.sync="percentageVisible" width="740px"
            class="import-stu-info-dialog" :append-to-body="true">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelImport">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 数据导入结果 -->
        <el-dialog title="数据导入结果" :visible.sync="dataResultVisible" width="740px" class="import-stu-info-dialog"
            :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="tip-info-main">
                <div class="import-table-con">
                    <p>
                        <i class="kz-icon-tishi"></i> 您本次共导入{{ count }}条数据，导入结果如下
                    </p>
                    <div>
                        <div class="clearfix down-load-btn">
                            <span class="fl sp-import-num">导入成功：{{ successNum }}条</span>
                            <a v-if="successNum > 0" :href="successUploadFileUrl">
                                <el-button type="primary" class="fr">下载导入成功记录</el-button>
                            </a>
                        </div>
                        <div class="clearfix down-load-btn">
                            <span class="fl sp-import-num">导入失败：{{ failNum }}条</span>
                            <a v-if="failNum > 0" :href="failUploadFileUrl">
                                <el-button type="primary" class="fr download-model-btn">下载导入失败记录</el-button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dataResultVisible = false">取 消</el-button>
                <el-button type="primary" @click="dataResultVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
        <!-- 批量删除 -->
        <el-dialog :before-close="cancel" title="批量删除" :visible.sync="DeleteAllDialogVisible" width="30%" top="3%"
            :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form ref="form" label-width="120px" size="mini">
                <el-form-item label="开始时间">
                    <el-date-picker v-model="deleteStartTime" type="datetime" placeholder="选择开始时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束时间">
                    <el-date-picker v-model="deleteEndTime" type="datetime" placeholder="选择结束时间">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDeleteAll">取 消</el-button>
                <el-button type="primary" @click="deleteAll()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 上传头像按钮 -->
        <el-dialog title="考生头像上传" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="touXiangDialog" :show-close="false" class="change-dialog-head-wrapper" width="50%">
            <div style="position: relative; line-height: 36px">
                <p style="font-size: 20px">选择证书类型</p>
                <el-select v-model="searchTypeId" clearable placeholder="请选择考核类型" @change="typeChnage">
                    <el-option v-for="item in searchCertTypeList" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </div>
            <div style="position: relative; line-height: 36px">
                <p style="font-size: 20px">注意事项:</p>
                <p style="color: red; font-size: 20px; margin-left: 50px">
                    1、照片的命名规则为身份证号.图片格式，如 341222200109179410.jpg
                </p>
            </div>
            <div slot="footer" class="dialog-footer">
                <stuActivtyUpload style="margin-right: 10px" :url="urlAliyunOSS" :ispartner="0" :files="files"
                    @done="onAllFilesUpload"></stuActivtyUpload>
                <el-button type="primary" @click="touXiangDialog = false">关 闭</el-button>
            </div>
        </el-dialog>
        <!-- 未匹配名单 -->
        <el-dialog title="未匹配名单" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false"
            :visible.sync="TisiDialog" :show-close="false" class="change-dialog-head-wrapper" width="50%">
            <div style="
          position: relative;
          line-height: 36px;
          height: 500px;
          overflow: scroll;
        ">
                <p style="color: red; font-size: 20px; margin-left: 50px" v-for="(item, index) in tisiList"
                    :key="index">
                    {{ index + 1 }}、{{ item }}
                </p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="TisiDialog = false">关 闭</el-button>
            </div>
        </el-dialog>
        <el-dialog title="在线证书展示" :modal="false" top="10px" :visible.sync="imageUrlShow" width="1280px">
            <div style="text-align: center">
                <img :src="imageUrl" style="width: 850px; height: 1200px;" />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="imageUrlClose">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
import stuActivtyUpload from "components/stuActivtyUpload.vue";
import importPhoto from "components/ImportPhoto.vue";


export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            stuName: "",
            schoolName: "",
            examName: "",
            idCard: "",
            certificateNum: "",
            examinationTypeId: "",
            examinationGradeId: "",
            list: [],
            from: {
                id: "",
                studentName: "",
                examName: "",
                examTime: "",
                examinationTypeId: "",
                examinationType: "",
                examinationGradeId: "",
                examinationGrade: "",
                siteName: "",
                idCard: "",
                qualifiedState: "合格",
                certificateNum: "",
                dateofIssue: "",
                examYMEnglish: "",
                examinationGradeEnglish: "",
                studentNamePinyin: "",
                studentUrl: "",
                certificateUrl: "",
                zsfx: "",
                sex: 0,
            },
            isSexDisabled: false,
            files: [],
            urlAliyunOSS: "/api/design/osssign/getsign",
            //编辑信息
            titleFormVisible: "",
            dialogFormVisible: false,
            //导入
            ImportDialogVisible: false,
            uploadUrl: "/api/XOrg/CertificateManager/uploadExcelPro",
            fileList: [], //导入文件
            errorList: [], //错误信息
            certTypeList: [],
            certGradeList: [],
            certTypeId: '',
            searchCertTypeList: [],
            searCertGradeList: [],
            // 导入结果
            dataResultVisible: false,
            wordUrl: "/public/docs/证书信息导入模板.xlsx",
            count: 0,
            successNum: 0,
            successFileName: "",
            failNum: 0,
            failFileName: "",
            // 批量删除
            DeleteAllDialogVisible: false,
            deleteStartTime: "",
            deleteEndTime: "",
            //
            percentageVisible: false,
            percentage: 0,
            taskId: "",
            timer: null,
            imageUrlShow: false,
            ids: [],
            selectedRows: [],
            //头像上传
            touXiangDialog: false,
            TisiDialog: false,
            tisiList: [],
            searchTypeId: '',
            //
            imageUrl: ""
        };
    },
    components: {
        imageUpload,
        stuActivtyUpload,
        importPhoto
    },
    computed: {
        failUploadFileUrl() {
            // return decodeURI("/api/Province/Major/uploadFile?filePath=" + this.failFileName);
            return decodeURI("/api/XOrg/ImportTask/uploadImportFile?id=" + this.taskId + "&type=2");
        },
        successUploadFileUrl() {
            // return decodeURI("/api/Province/Major/uploadFile?filePath=" + this.successFileName);
            return decodeURI("/api/XOrg/ImportTask/uploadImportFile?id=" + this.taskId + "&type=1");
        },
        exportExam() {
            return (
                "/api/XOrg/CertificateManager/exportExamExcel?studentName=" +
                encodeURIComponent(this.stuName) +
                "&schoolName=" +
                encodeURIComponent(this.schoolName) +
                "&examName=" +
                encodeURIComponent(this.examName) +
                "&idCard=" +
                encodeURIComponent(this.idCard) +
                "&ExaminationGradeId=" +
                encodeURIComponent(this.examinationGradeId) +
                "&CertificateTypeId=" +
                encodeURIComponent(this.examinationTypeId) +
                "&certificateNum=" +
                encodeURIComponent(this.certificateNum) +
                "&type=0"
            );
        },
        exportCertificateZipUrl() {
            return (
                "/api/XOrg/CertificateManager/exportCertificateZip?ids=" +
                encodeURIComponent(
                    this.selectedRows
                        .filter((item) => item.certificateUrl)
                        .map((item) => item.id)
                        .join(",")
                ) +
                "&type=0"
            );
        },
    },
    created() {
        this.getStudentResultInfo();
        this.getCertificateType();
        this.getSearchCertificateType();

    },
    watch: {
        // eslint-disable-next-line no-unused-vars
        "from.examinationTypeId": function (val) {
            this.getCertificateGrade();
        },
        // eslint-disable-next-line no-unused-vars
        "examinationTypeId": function (val) {
            this.getSearchCertificateGrade();
        },
    },
    methods: {
        handleIdCardChange() {
           
            const idCard = this.from.idCard;
            if (idCard.length === 18) {
                // 提取身份证号第 17 位
                const genderDigit = parseInt(idCard.charAt(16), 10);
                // 判断性别，奇数为男，偶数为女
                this.from.sex = genderDigit % 2 === 1 ? 0 : 1;
                this.isSexDisabled = true;
            } else {
                this.isSexDisabled = false;
            }
        },
        clickImg(url) {
            this.imageUrl = url;
            this.imageUrlShow = true;
        },

        imageUrlClose() {
            this.imageUrlShow = false;
        },
        handleSelectionChange(val) {
            this.selectedRows = val;
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.id);
            });
        },
        exportCertificate(row) {
            if (!row.certificateUrl) {
                this.$message.warning("该记录还没有生成证书");
                return;
            }
            window.location.href =
                "/api/XOrg/CertificateManager/exportCertificate?id=" +
                encodeURIComponent(row.id);
        },
        exportCertificateZip() {
            if (this.ids.length === 0) {
                this.$message.warning("请先勾选需要导出的证书");
                return;
            }
            if (!this.selectedRows.some((item) => item.certificateUrl)) {
                this.$message.warning("勾选的记录还没有生成证书");
                return;
            }
            window.location.href = this.exportCertificateZipUrl;
        },
        deleteAll() {
            var that = this;
            this.$confirm("此操作将删除该时间段证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                that.$http
                    .post("/api/XOrg/CertificateManager/deleteCertificateAll", {
                        startTime: this.deleteStartTime,
                        endTime: this.deleteEndTime
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.DeleteAllDialogVisible = false;
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        // 取消进度条
        cancelImport() {
            var that = this;
            that.$http
                .post('/api/XOrg/ImportTask/cancelImport', {
                    id: that.taskId,
                })
                .then(function () {
                    that.percentageVisible = false;
                    clearInterval(that.timer);
                })
        },
        cancelDeleteAll() {
            this.DeleteAllDialogVisible = false;
            this.deleteStartTime = "";
            this.deleteEndTime = "";
        },
        getSearchCertificateType() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateTypeManager/getCertificateType", {
                    type: 0
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.searchCertTypeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getSearchCertificateGrade() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: this.examinationTypeId
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.searCertGradeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        getCertificateType() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateTypeManager/getCertificateType", {
                    type: 0
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.certTypeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        typeChnage() {
            // this.getCertificateGrade();
            this.from.examinationGradeId = "";
        },
        getCertificateGrade() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
                    typeId: this.from.examinationTypeId
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.certGradeList = rst.list;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        cancelInfo() {
            this.from.id = "";
            this.from.studentName = "";
            this.from.examName = "";
            this.from.examTime = "";
            this.from.examinationTypeId = "";
            this.from.examinationType = "";
            this.from.examinationGradeId = "";
            this.from.examinationGrade = "";
            this.from.siteName = "";
            this.from.idCard = "";
            this.from.qualifiedState = "";
            this.from.certificateNum = "";
            this.from.dateofIssue = "";
            this.from.examYMEnglish = "";
            this.from.examinationGradeEnglish = "";
            this.from.studentNamePinyin = "";
            this.from.studentUrl = "";
            this.from.certificateUrl = "";
            this.dialogFormVisible = false;
        },
        onSuccess(res) {
            var that = this;
            if (res.code > 0) {
                this.ImportDialogVisible = false;
                this.percentageVisible = true;
                this.taskId = res.taskId;
                this.timer = setInterval(function () {
                    that.$http
                        .post('/api/XOrg/ImportTask/getImportProgress', {
                            id: res.taskId,
                        })
                        .then(function (rst) {
                            if (rst.code > 0) {
                                that.percentage = rst.info.progressBar;
                                if (that.percentage == 100) {
                                    clearInterval(that.timer);
                                    that.failNum = rst.info.failNumber;
                                    that.successNum = rst.info.successNumber;
                                    that.count = rst.info.importCount;
                                    that.dataResultVisible = true;
                                    that.percentageVisible = false;
                                    that.percentage = 0;
                                    that.page = 1;
                                    that.getStudentResultInfo();
                                }
                            } else {
                                that.$message.warning(rst.msg)
                            }
                        })
                }, 2000);
            } else {
                this.$message.warning(res.msg);
            }
            // if (res.code > 0) {
            //     this.ImportDialogVisible = false;
            //     this.fileList = [];
            //     this.dataResultVisible = true;
            //     this.count = res.info.count;
            //     this.successNum = res.info.successNum;
            //     this.successFileName = res.info.successFileName;
            //     this.failNum = res.info.failNum;
            //     this.failFileName = res.info.failFileName;
            //     this.getStudentResultInfo();
            // } else {
            //     this.fileList = [];
            //     this.$message.warning(res.msg);
            // }

        },
        //导入题库
        importFile() {
            this.$refs.upload.submit();
        },
        //清除数据
        cancel() {
            this.ImportDialogVisible = false;
            this.fileList = [];
        },
        addInfo() {
            this.titleFormVisible = "新增";
            this.dialogFormVisible = true;
        },
        //编辑
        editInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateManager/addOrEditCertificate", {
                    id: this.from.id,
                    studentName: this.from.studentName,
                    examName: this.from.examName,
                    examTime: this.from.examTime,
                    examinationGradeId: this.from.examinationGradeId,
                    examinationTypeId: this.from.examinationTypeId,
                    siteName: this.from.siteName,
                    idCard: this.from.idCard,
                    qualifiedState: this.from.qualifiedState,
                    certificateNum: this.from.certificateNum,
                    dateofIssue: this.from.dateofIssue,
                    studentUrl: this.from.studentUrl,
                    certificateUrl: this.from.certificateUrl,
                    studentNamePinyin: this.from.studentNamePinyin,
                    zsfx: this.from.zsfx,
                    type: 0,
                    sex:this.from.sex
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.$message.success(rst.msg);
                        that.cancelInfo();
                        that.getStudentResultInfo();
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        //弹出框赋值
        handleEdit(row) {
            this.from.id = row.id;
            this.from.studentName = row.studentName;
            this.from.examName = row.examName;
            this.from.examTime = row.examTime;
            this.from.examinationGradeId = row.examinationGradeId;
            this.from.examinationTypeId = row.certificateTypeId;
            this.from.siteName = row.siteName;
            this.from.idCard = row.idCard;
            this.from.qualifiedState = row.qualifiedState;
            this.from.certificateNum = row.certificateNum;
            this.from.dateofIssue = row.dateofIssueData;
            this.from.examYMEnglish = row.examYMEnglish;
            this.from.examinationGradeEnglish = row.examinationGradeEnglish;
            this.from.studentNamePinyin = row.studentNamePinyin;
            this.from.studentUrl = row.studentUrl;
            this.from.certificateUrl = row.certificateUrl;
            this.from.zsfx = row.zsfx;
            this.from.sex=row.sex;
            this.titleFormVisible = "编辑";
            this.dialogFormVisible = true;
            this.handleIdCardChange();

        },
        //删除
        deleteInfo(id) {
            var that = this;
            this.$confirm("此操作将删除该证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                that.$http
                    .post("/api/XOrg/CertificateManager/deleteCertificateInfo", {
                        ids: id
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //查询
        getStudentResultInfo() {
            var that = this;
            this.$http
                .post("/api/XOrg/CertificateManager/getCertificateList", {
                    studentName: this.stuName,
                    schoolName: this.schoolName,
                    examName: this.examName,
                    idCard: this.idCard,
                    ExaminationGradeId: this.examinationGradeId,
                    CertificateTypeId: this.examinationTypeId,
                    certificateNum: this.certificateNum,
                    type: 0,
                    PageSize: that.pageSize,
                    page: that.page
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getStudentResultInfo();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getStudentResultInfo();
        },
        multiCreateCertificate() {
            this.handleCreatedCertificate(this.ids);
        },
        multiDeleteCertificate() {
            var that = this;
            var ids = this.ids;
            if (ids.length == 0) {
                that.$message.warning("请选择要删除的证书数据");

                return;
            }

            this.$confirm("此操作将删除" + ids.length + "条证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/CertificateManager/deleteCertificateInfo", {
                        ids: ids,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        handleCreatedCertificate(id) {
            var that = this;
            this.$confirm("此操作将重新生成该证书数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                that.$http
                    .post("/api/XOrg/CertificateManager/createdCertificate", {
                        ids: id,
                    })
                    .then(function (rst) {
                        if (rst.code > 0) {
                            that.$message.success(rst.msg);
                            that.getStudentResultInfo();
                        } else {
                            that.$message.warning(rst.msg);
                        }
                    });
            });
        },
        //上传头像弹窗
        openTXtDialog() {
            this.touXiangDialog = true;
        },
        //学生头像上传
        onAllFilesUpload(file) {
            this.$http
                .post("/api/XOrg/CertificateManager/saveStuCertificateFile", {
                    fileList: JSON.stringify(file),
                    typeId: this.searchTypeId
                })
                .then((res) => {
                    if (res.code > 0) {
                        if (res.list.length == 0) {
                            this.$message.success(res.msg);
                            this.touXiangDialog = false;
                        } else {
                            this.TisiDialog = true;
                            this.tisiList = res.list;
                        }
                        this.getStudentResultInfo();
                    } else {
                        this.$message.warning(res.msg);
                    }
                });
        },
    }
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .certificate-manager-table {
        width: 100%;
        margin-top: 8px;
    }

    .u-page-con {
        margin-top: 12px;
    }

    .export-button-a {
        padding: 9px 15px;
        background-color: #409eff;
        font-size: 12px;
        border-radius: 3px;
    }

    .certificate-operation-column {
        .cell {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            white-space: nowrap;
        }

        .el-button + .el-button {
            margin-left: 8px;
        }
    }

    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2F7DFF;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1A2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #D8E0E6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #E65B72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #EE6C3A;
        border-color: #EE6C3A;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }
}
</style>
